import axiosInstance from './AxiosInstance';

const API_URL = 'jobdescriptions';

export const getJobs = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching jobs', error);
        throw error;
    }
};

export const getJobById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching job with id ${id}`, error);
        throw error;
    }
};

export const createJob = async (job) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, job);
        return response.data;
    } catch (error) {
        console.error('Error creating job', error);
        throw error;
    }
};

export const updateJob = async (id, job) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...job });
        return response.data;
    } catch (error) {
        console.error(`Error updating job with id ${id}`, error);
        throw error;
    }
};

export const deleteJob = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting job with id ${id}`, error);
        throw error;
    }
};

export const getJobTitles = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/getJobTitles`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching job titles list`, error);
        throw error;
    }
};

